import { useContext } from 'react'
import { getUserId } from 'services/user'
import ReactGA from 'react-ga'
import { RELEASE_VERSION } from 'utils/constants'
import { firebaseAnalytics } from 'index'

import { apiContext } from './ApiContext'

// eslint-disable-next-line import/prefer-default-export
export const useEvents = () => {
  const ctx = useContext(apiContext)

  const publishEvent = (category, type, additional = '') => {
    if (!ctx || !ctx.user) {
      errorEvent('REPORT_EVENT', new Error(`No user existing when firing event ${type}`))
      return
    }

    const { user } = ctx
    if (['ADMIN', 'SUPPORT'].includes(user.userStatus)) return
    if (!type) type = category

    sendEvent({
      category,
      action: `${type} by user ${user.userId}`,
      label: `${metadata()} ${additional}`,
    })
  }

  return publishEvent
}

export const errorEvent = (category, error) => {
  // const user = { ...userState, email: userState.email.replace('@', '§') } // ReactGA somehow redacts email addresses

  // Currently (somehow) not shown in dashboard -> TODO (Maybe outdated analytics.js function used in react-ga 3rd party lib?)
  // ReactGA.exception({
  //   description: JSON.stringify(error),
  //   fatal: true
  // })

  // For nested error objects use serializeError package (after upgrade to react-app-rewired 2.x (cra v2 or v3) -> TODO: Otherwise minify error
  const userId = getUserId()
  sendEvent({
    category: 'ERROR',
    action: `${category} ERROR : ${error.message}`,
    label: `User: ${JSON.stringify(userId)}; Error: ${JSON.stringify(
      error,
      replaceErrors,
    )}; ${metadata()}`,
  })
}

export const registerEvent = (userState) => {
  sendEvent({
    category: 'REGISTRATION',
    action: `REGISTRATION by user ${userState.userId}`,
    label: metadata(),
  })
}

export const loginEvent = (user) => {
  if (!user) errorEvent('REPORT_EVENT', new Error(`No user existing when firing LOGIN event`))
  if (['ADMIN', 'SUPPORT'].includes(user.userStatus)) return

  sendEvent({
    category: 'LOGIN',
    action: `LOGIN by user ${user.userId}`,
    label: metadata(),
  })
}

const metadata = () => {
  const { location } = window
  return `Timestamp: ${new Date().toISOString()}; Version: ${RELEASE_VERSION}; Location: ${
    location ? JSON.stringify(location.href) : ''
  }`
}

function replaceErrors(_, value) {
  if (value instanceof Error) {
    const error = {}

    Object.getOwnPropertyNames(value).forEach((k) => {
      error[k] = value[k]
    })

    return error
  }

  return value
}

const sendEvent = (data) => {
  const { category, ...restData } = data

  ReactGA.event(data)
  firebaseAnalytics.logEvent(category, restData)
}
